const EDITOR_USER = Object.freeze({
	ID: 'userId',
	CONTACT_ID: 'contactId',
	V_FILE_ID: 'vFileId',
	IS_ENABLED: 'isEnabled',
	FIRST_NAME: 'firstName',
	LAST_NAME: 'lastName',
	USERNAME: 'username',
	PHONE_WORK: 'phoneWork',
	PHONE_WORK_DIAL_CODE: 'phoneWorkDialCode',
	PHONE_WORK_COUNTRY_CODE: 'phoneWorkCountryCode',
	PHONE_WORK_EXT: 'phoneWorkExt',
	PHONE_MOBILE: 'phoneMobile',
	PHONE_MOBILE_DIAL_CODE: 'phoneMobileDialCode',
	PHONE_MOBILE_COUNTRY_CODE: 'phoneMobileCountryCode',
	PHONE_MOBILE_EXT: 'phoneMobileExt',
	PHONE_OTHER: 'phoneOther',
	PHONE_OTHER_DIAL_CODE: 'phoneOtherDialCode',
	PHONE_OTHER_COUNTRY_CODE: 'phoneOtherCountryCode',
	PHONE_OTHER_EXT: 'phoneOtherExt',
	EMAIL_WORK: 'emailWork',
	EMAIL_PERSONAL: 'emailPersonal',
	EMAIL_OTHER: 'emailOther',
	LANGUAGES: 'userLanguages',
	CONTACT_TYPES: 'userContactTypes',
	ROLE_GROUPS: 'userRoleGroups',
	COMPANIES: 'userCompanies',
	ACCESSIBLE: 'userAccessible',
	ADDRESSES: 'userAddresses',
	UNIT: 'unit',
	ADDRESS_WORK: 'userAddressWork',
	ADDRESS_HOME: 'userAddressHome',
	ADDRESS_OTHER: 'userAddressOther',
	DELETE_ADDRESS: 'deleteUserAddress',
	NOTES: 'notes',
	IMAGE: 'image',
	FILE: 'file',
	PASSWORD: 'password',
	CONFIRM_PASSWORD: 'confirmPassword',
	WORK: 'Work',
	HOME: 'Home',
	OTHER: 'Other',
});

export default EDITOR_USER;
